import Header from "./Header";
import Container from "./Container";
import Footer from "./Footer";

import "../scss/index.scss";

const App = () => {
    return (
        <>
            <Header />
            <Container />
            <Footer />
        </>
    )
};

export default App;